<template>
  <div class="privacy-page">
    <v-container>
      <h1 class="text-h3 mb-8">隐私政策</h1>
      <p>页面建设中...</p>
    </v-container>
  </div>
</template>

<script setup lang="ts">
</script> 